import { render } from "./UpdateHistory.vue?vue&type=template&id=347792aa&scoped=true"
import script from "./UpdateHistory.vue?vue&type=script&lang=js"
export * from "./UpdateHistory.vue?vue&type=script&lang=js"

import "./UpdateHistory.vue?vue&type=style&index=0&id=347792aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347792aa"]])

export default __exports__